import { render, staticRenderFns } from "./StudentLayout.vue?vue&type=template&id=57c23599&scoped=true"
import script from "./StudentLayout.vue?vue&type=script&lang=js"
export * from "./StudentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c23599",
  null
  
)

export default component.exports